import { graphql } from '../graphql';

/**
 * Layer-context entry point: takes an existing POINTCLOUD layer + mesh export
 * parameters and returns the synthetic batch ID created by the server.
 * Mirrors `startGroundClassification` in groundClassify.query.ts.
 */
export const startMeshExport = graphql(`
  mutation StartMeshExport($input: StartMeshExportInput!) {
    startMeshExport(input: $input)
  }
`);
